module.exports = __webpack_public_path__ + "img/finn.85643246.png";